import { DailyCashPage } from './cash/DailyCashPage';

/** TX3 — Mi caja / Caja del día */
export function CashRegistersPage() {
  return (
    <div className="p-6">
      <DailyCashPage />
    </div>
  );
}
